export const AnalysisCustomerDetail = {
    path: '/analysis/customer/detail/:type',
    name: 'analysis.customer.detail',
    component: () => import('@/views/Analysis/AnalysisCustomerDetail.vue'),
    children: [
        {
            path: '/analysis/customer/detail/view/physician/:id',
            name: 'analysis.customer.detail.physician.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'physician'}
        },
        {
            path: '/analysis/customer/detail/view/pharmacy/:id',
            name: 'analysis.customer.detail.pharmacy.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'pharmacy'}
        },
        {
            path: '/analysis/customer/detail/view/wholesaler/:id',
            name: 'analysis.customer.detail.wholesaler.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'wholesaler'}
        },
        {
            path: '/analysis/customer/detail/visit/physician/view/:id',
            name: 'analysis.customer.detail.visit.physician.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
        {
            path: '/analysis/customer/detail/visit/pharmacy/view/:id',
            name: 'analysis.customer.detail.visit.pharmacy.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
        {
            path: '/analysis/customer/detail/visit/wholesaler/view/:id',
            name: 'analysis.customer.detail.visit.wholesaler.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
    ]
}